var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    className: "svg-icon ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 17h-.8v2.3h.8V17zm12.3 0h-.7v2.3h.7V17zm-9.2.8h-.8v.8h.8v-.8zm-6.2 0h-.8v.8h.8v-.8zm1.5 0h-.7v.8h.7v-.8zm3.1 0H7v.8h.7v-.8zm7.8 0h-.8v.8h.8v-.8zm-1.6 0h-.8v.8h.8v-.8zm7.7 0h-.7v.8h.7v-.8zm-10.8 0H10v.8h.8v-.8zm9.3 0h-.8v.8h.8v-.8zm-3.1 0h-.8v.8h.8v-.8zm-15.5 0H.8v-1.6H0v3.9h.8v-1.5h.7v-.8zm21.7 0h-.8v.8h.8v1.5h.8v-3.9h-.8v1.6zM12.4 17h-.8v2.3h.8V17zm11.4-7.3c-1.1-4-12.4-5.3-16.7-4.5-1.4.7-3 1.3-4.1 2.5-1.2-.1-1.6 0-1.5.8-.4.2-.9.4-.9.9-.1.2-.6.9-.5 1.1 1.2-.4 2.2-1.1 2.9-2 .6 0 1-.1 1.2-.2 4.2-.8 7.7 2.5 12 2-1.2 2.4.1 2.7 2 0 1.7-.6 4.2.2 5.6-.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthIcon);
export default __webpack_public_path__ + "static/media/length-icon.d3b306ee8e3a0c6b16987a6b54463318.svg";
export { ForwardRef as ReactComponent };